"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _codemirror = _interopRequireDefault(require("codemirror"));

require("codemirror/addon/mode/multiplex");

require("codemirror/addon/mode/overlay");

require("codemirror/mode/css/css");

require("codemirror/mode/xml/xml");

require("codemirror/mode/javascript/javascript");

require("codemirror/mode/jinja2/jinja2");

require("codemirror/mode/htmlmixed/htmlmixed");

/*
 * Adds 3 custom HubL modes to CodeMirror.
 *   hubl-css
 *   hubl-html
 *   hubl-javascript
 *
 * Adds 3 custom HubL mime modes to CodeMirror.
 *   text/x-hubl-css
 *   text/x-hubl-html
 *   text/x-hubl-javascript
 *
 * These modes will use the jinja2 parser within and including code between open/close.
 * The following classes will be appended to each tag within.
 *   cm-hubl-comment
 *   cm-hubl-statement
 *   cm-hubl-expression
 */
function createHublCommentMode(config) {
  return {
    open: '{#',
    close: '#}',
    mode: _codemirror.default.getMode(config, 'hubl'),
    parseDelimiters: true,
    innerStyle: 'hubl-comment'
  };
}

function createHublStatementMode(config) {
  return {
    open: '{%',
    close: '%}',
    mode: _codemirror.default.getMode(config, 'hubl'),
    parseDelimiters: true,
    innerStyle: 'hubl-statement'
  };
}

function createHublExpressionMode(config) {
  return {
    open: '{{',
    close: '}}',
    mode: _codemirror.default.getMode(config, 'hubl'),
    parseDelimiters: true,
    innerStyle: 'hubl-expression'
  };
}

function createMultiplex(config, basemode) {
  return _codemirror.default.multiplexingMode(_codemirror.default.getMode(config, basemode), createHublCommentMode(config), createHublStatementMode(config), createHublExpressionMode(config));
}
/**
 * Base hubl mode that overlays the jinja2 mode.
 */


_codemirror.default.defineMode('hubl', function (config) {
  var keywords = ['unless', 'endunless', 'set', 'import'];
  var keywordRegex = new RegExp("((" + keywords.join(')|(') + "))\\b");
  return _codemirror.default.overlayMode(_codemirror.default.getMode(config, 'jinja2'), {
    token: function token(stream) {
      if (stream.match(keywordRegex)) {
        return 'keyword';
      }

      while (stream.next() != null && !stream.match(keywordRegex, false)) {
        ;
      }

      return null;
    }
  });
});

_codemirror.default.defineMode('hubl-css', function (config) {
  return createMultiplex(config, 'css');
});

_codemirror.default.defineMode('hubl-html', function (config) {
  return createMultiplex(config, 'htmlmixed');
});

_codemirror.default.defineMode('hubl-javascript', function (config) {
  return createMultiplex(config, 'javascript');
});

_codemirror.default.defineMIME('text/x-hubl', 'hubl');

_codemirror.default.defineMIME('text/x-hubl-css', 'hubl-css');

_codemirror.default.defineMIME('text/x-hubl-html', 'hubl-html');

_codemirror.default.defineMIME('text/x-hubl-javascript', 'hubl-javascript');